<template>
  <div class="mysite">
    <van-checkbox-group v-model="result" name="checkboxGroup">
      <van-cell-group>
        <van-cell v-for="(item, index) in list" clickable :key="index" :title="item.stationName"
          @click="toggle(index)">
          <template #right-icon>
            <van-checkbox checked-color="#FFD100" :name="index" ref="checkboxes" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
    <div class="submit">
      <div class="button-tj font30 cfff btncolor" @click="siteSubmit()">提交</div>
    </div>
  </div>
</template>
<script>
  // import Tabbar from '../components/tabbar.vue'
  import {
    Toast
  } from 'vant'
  // import { Checkbox, CheckboxGroup } from 'vant'
  export default {
    name: 'mySite', // 个人中心
    components: {
      // 'Tabbar': Tabbar
    },

    data() {
      return {
        list: [],
        result: [],
        longitude:'',
        latitude:''
      }
    },
    created() {

    },
    mounted() {
      var that =this
      var options = {
        timeout: 3000
      };
      var geolocation = new qq.maps.Geolocation("H7XBZ-QF4WK-XNJJ5-AQMFZ-TVASQ-3QF7Q", "myapp");
      // 定位成功之后调用的方法
      function showPosition(position) {
        let lat = position.lat;
        let lng = position.lng;
        this.longitude=lng
        this.latitude=lat
        that.getIndexInfo()
      };

      function showErr() {
        Toast('获取位置信息失败')
      }
      geolocation.getLocation(showPosition, showErr, options);

    },

    methods: {
      toggle(index) {
        this.$refs.checkboxes[index].toggle()
      },
      // 请求数据
      getIndexInfo() {
        this.$api.HZrequest('/we-chat/gzh/washer/push/get', 'GET', {'longitude':this.longitude,'latitude':this.latitude}).then((res) => {
          this.list = res.data
          this.list.forEach((val, index, arr) => {
            if (val.status == '0') {
              this.result.push(index)
            }
          })
        })
      },
      siteSubmit() {
        var that = this
        this.list.forEach((val, index, arr) => {
          val.status = '1'
        })
        this.result.forEach((val, index, arr) => {
          this.list[val].status = '0'
        })
        this.$api.HZrequest('/we-chat/gzh/washer/push/update', 'POST', this.list).then((res) => {
          if (res.code == 200) {
            Toast('修改成功')
            setTimeout(function() {
              that.$router.go(-1)
            }, 500)
          } else {
            Toast('修改失败，请重新提交')
          }
        })
      }
    }

  }
</script>

<style>
  .mysite {
    padding-bottom: 1.4rem;
  }

  .submit {
    width: 100%;
    background: #fff;
    height: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
  }

  .button-tj {
    width: 90%;
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.48rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/mySite.vue